<template>
  <div class="my">
    <div class="login">
      <span @click="toXpage('/login')" v-if="user.name == ''">登 录</span>
      <div class="accname" v-if="user.name !== ''">{{ user.name }}</div>
    </div>
    <div class="mylist">
      <div @click="toXpage('/myGoods')">我的购买</div>
      <div @click="toXpage('/errSub')">报错提交</div>
      <div @click="toXpage('/setUp')">基础设置</div>
      <div @click="logout()">退出登录</div>
      <div @click="toXpage('/goodsAdmin')" v-if="user.iden == 'admin'">商品管理</div>
      <div @click="toXpage('/userAdmin')" v-if="user.iden == 'admin'">账号管理</div>
      <div @click="toXpage('/errAdmin')" v-if="user.iden == 'admin'">报错管理</div>
    </div>

  </div>
</template>

<script>
// import store from '@/store'


export default {
  name: 'myView',
  components: {

  },
  data() {
    return {

    }
  },
  computed: {
    user() {
      return this.$store.state.userInfo
    },
    // 判断是否登录
    isLoggedIn() {
      return Object.keys(this.user).length > 0;
    }
  },
  created() {

  },
  methods: {
    toXpage(path) {
      if (this.$router.path !== path) {
        this.$router.push(path)
      }
    },
    logout() {
      localStorage.removeItem('handingtoken')
      this.$store.commit('clearUser')
      // this.$router.push('/login')
      console.log('退出登录')
    },
  }
}
</script>

<style scoped lang="scss">
.my {
  width: 100%;
  height: 100%;
  // background-color: rgb(0, 81, 255);
  padding-top: 50rem;
  overflow: auto;
  background: url(../../assets/beijing2.jpg) center/100%;

  .login {
    width: 95%;
    height: 20vh;
    margin: auto;
    /* margin-bottom: 50rem; */
    border: 1rem solid rgb(240, 248, 255, 0.5);
    border-radius: 30rem;
    box-shadow: 10rem 10rem rgba(0, 0, 0, 0.5);
    background-color: rgb(240, 248, 255, 0.5);
    font-size: 6vh;
    font-weight: 900;
    color: rgb(54, 51, 47);
    text-align: center;
    line-height: 20vh;

    .accname {
      width: 80vw;
      height: 16vh;
      margin: 2vh auto;
      border-radius: 50rem;
      background-color: rgb(0, 139, 139, 0.5);
      text-align: center;
      line-height: 16vh;
      overflow: hidden;
    }
  }

  .mylist {
    width: 100%;
    /* height: 80vh; */
    padding-top: 50rem;

    div {
      width: 95%;
      height: 8vh;
      margin: auto;
      margin-bottom: 50rem;
      border: 1rem solid rgb(240, 248, 255, 0.5);
      border-radius: 30rem;
      box-shadow: 10rem 10rem rgba(0, 0, 0, 0.5);
      background-color: rgb(240, 248, 255, 0.5);
      font-size: 4vh;
      font-weight: 800;
      color: rgb(54, 51, 47);
      text-align: center;
      line-height: 8vh;
    }
  }
}

.my::-webkit-scrollbar {
  display: none;
}
</style>